export const RTE_SHORTCUTS_DIALOG_TITLE = "Keyboard shortcuts";
export const RTE_SHORTCUTS_DIALOG_DESCRIPTION =
  "Shortcuts for the rich text editor (WYSIWYG).";

export const RTE_MARKDOWN_DIALOG_TITLE = "Markdown formatting";
export const RTE_MARKDOWN_DIALOG_DESCRIPTION =
  "In Markdown mode you type formatting and variables directly.";

export const RTE_TOOLTIP_UNDO = "Undo";
export const RTE_TOOLTIP_REDO = "Redo";
export const RTE_TOOLTIP_BOLD = "Bold";
export const RTE_TOOLTIP_ITALIC = "Italic";
export const RTE_TOOLTIP_STRONG = "Strong (screen readers)";
export const RTE_TOOLTIP_EMPHASIZED = "Emphasized (screen readers)";
export const RTE_TOOLTIP_BULLET_LIST = "Bullet list";
export const RTE_TOOLTIP_ORDERED_LIST = "Numbered list";
export const RTE_TOOLTIP_INSERT_APOSTROPHE = "Insert apostrophe";
export const RTE_TOOLTIP_INSERT_HORIZONTAL_RULE = "Insert horizontal rule";
export const RTE_TOOLTIP_INSERT_VARIABLE = "Insert variable";
export const RTE_SHORTCUT_INSERT_DIRECTIVE_VARIABLE =
  "Insert directive variable";

export const RTE_NO_VARIABLES = "No variables available.";
